<template>
  <footer class="relative idx2">
    <step-routing v-if="route.name !== 'Step11'" />
    <invoice-routing v-else />
  </footer>
</template>

<script>
import StepRouting from "@/modules/moduleA/components/footer/StepRouting";
import {useRoute} from "vue-router";
import InvoiceRouting from "@/modules/moduleA/components/footer/InvoiceRouting";
export default {
name: "index",
  components: {InvoiceRouting, StepRouting},
  setup(){
    const route = useRoute()
    return {route}
  }
}
</script>

<style scoped>
footer {
  position: fixed;
  z-index: 999;
  bottom: 0;
  width: 100%;
  height: 80px;
}
</style>
